module.exports = __webpack_public_path__ + "img/fayaz_bhai_avatar.ec784567.png";